import { Component } from '@angular/core';
import { ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";

@Component({
  selector: 'page-xp-report-add-repair',
  templateUrl: 'xp-report-add-repair.html',
})
export class XpReportAddRepairPage {

  items = [];
  form: FormGroup;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public barcodeScanner: BarcodeScanner,
    public viewCtrl: ViewController
  ) {
    this.items = this.navParams.get('items');
    this.form = this.formBuilder.group({
      description: ['', Validators.required],
      code: [''],
      part_title: [''],
      part_ean: [''],
      remark: ['']
    });
  }

  setPart(record){
    this.form.patchValue(record);
  }

  save(){
    this.items.push(this.form.value);
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportAddRepairPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report-add-repair/xp-report-add-repair.ts